<template>
  <v-tooltip left>
    <template #activator="{ on }">
      <span v-on="on">
        <v-btn
          :color="state ? 'success' : 'error'"
          icon
          @click="updateApplicationState"
        >
          <v-icon>
            {{ state ? 'toggle_off' : 'toggle_on' }}
          </v-icon>
        </v-btn>
      </span>
    </template>
    {{ `${state ? 'Disable' : 'Enable'} application ${name}` }}
  </v-tooltip>
</template>

<script>
import { wrapToLoadingFn } from '@helpers';

import ApplicationsApiService from '../_services/applications.api.service';

export default {
  name: 'UmsApplicationStateSwitcher',
  props: {
    state: Boolean,
    name: {
      type: String,
      required: true,
    },
  },
  methods: {
    wrapToLoadingFn,
    updateApplicationState() {
      const { name, state: currentState } = this;

      this.$VBlackerTheme.alert.warning({
        text: `${currentState ? 'Disable' : 'Enable'} application '${name}'`,
      }, () => this.wrapToLoadingFn({
        req: ApplicationsApiService.updateApplicationState.bind({}, {
          name,
          state: Number(!currentState),
        }),
        onSuccess: () => {
          this.$VBlackerTheme.notification('Application state successfully changed');
          this.$emit('success');
        },
      }));
    },
  },
};
</script>
